import ConfigProvider from '@alifd/next/lib/config-provider';
export default ConfigProvider;